<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="user.FirstName + ' ' + user.LastName + ' [User Management] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0 d-block d-md-inline-block">
                    <li class="breadcrumb-item font-weight-light d-block d-md-inline-block" v-if="this.$root.hasPermission(['settings.manage.users', 'settings.view.users'])">
                        <router-link :to="`/users`">
                            <i class="fa fa-user"></i> Users
                        </router-link>
                    </li>
                    <template v-else>
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block">
                            <router-link :to="`/subcontractors`">
                                <i class="fa fa-id-badge"></i> Subcontractors
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light d-block d-md-inline-block mt-md-0 mt-2">
                        <router-link :to="`/subcontractors/users`">
                            <i class="fa fa-group"></i> Users
                        </router-link>
                    </li>
                    </template>
                    <li class="breadcrumb-item active d-block d-md-inline-block mt-md-0 mt-2">
                        {{ user.FirstName }} {{ user.LastName }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>
                                User Details
                                <span class="badge badge-warning" v-if="user.subcontractor_id">Subcontractor User</span>
                                <span class="badge badge-danger" v-if="user.deleted_at !== null">Deleted</span>
                            </strong>
                            <template v-if="this.$root.hasPermission('settings.manage.users') || (this.$root.hasPermission('subcontractors.manage') && user.subcontractor_id != null)">
                                <div v-if="user.deleted_at === null" class="pull-right">
                                    <router-link :to="`/users/edit/${user.UserId}`" class="btn btn-sm btn-light">
                                        <i class="fa fa-edit"></i> Edit
                                    </router-link>
                                    <button @click="deleteUser" class="btn btn-sm btn-light">
                                        <i class="fa fa-trash"></i> Delete
                                    </button>
                                </div>
                                <div v-else class="pull-right">
                                    <button @click="restoreUser" class="btn btn-sm btn-light">
                                        <i class="fa fa-undo"></i> Restore
                                    </button>
                                    <button v-if="user.EmployeeId" @click="removeEmployee" class="btn btn-sm btn-light">
                                        <i class="fa fa-group"></i> Remove Employee
                                    </button>
                                </div>
                            </template>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-8">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Status</div>
                                        <div class="col-md-8">
                                            <span class="badge badge-success" v-if="user.IsActive == 1">Active</span>
                                            <span class="badge badge-warning" v-else>Inactive</span>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Name:</div>
                                        <div class="col-md-8">{{ user.FirstName }} {{ user.LastName }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Email:</div>
                                        <div class="col-md-8">{{ user.email }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Title:</div>
                                        <div class="col-md-8">{{ user.title }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Timezone:</div>
                                        <div class="col-md-8">{{ user.timezone_slug }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Last Login:</div>
                                        <div class="col-md-8">{{ user.LastLoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Current Jobsite:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/jobsites/view/${user.current_jobsite_id}`" v-if="user.current_jobsite_id">
                                                {{ user.JobsiteNumber }} - {{ user.JobsiteName }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="user.subcontractor_id">
                                        <div class="col text-muted">Subcontractor:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/subcontractors/view/${user.subcontractor_id}`" title="View Subcontractor">
                                                {{ user.subcontractor_name }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3" v-if="user.subcontractor_id">
                                        <div class="col text-muted">Qualification Permission:</div>
                                        <div class="col-md-8">
                                            <template v-if="user.sub_permissions">{{ user.sub_permissions }}</template>
                                            <template v-else>-- No Qualification Permissions --</template>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Employee Record:</div>
                                        <div class="col-md-8">
                                            <router-link :to="`/employees/view/${user.EmployeeId}`" title="View Employee Record" v-if="user.EmployeeId">
                                                {{ user.EmployeeFirstName }} {{ user.EmployeeLastName }} - {{ user.EmployeeNumber }}
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Employee#:</div>
                                        <div class="col-md-8">
                                            {{ user.EmployeeNumber }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Primary Division:</div>
                                        <div class="col-md-8">
                                            <template v-if="user.DivisionId">
                                                <span v-if="user.division_code">{{ user.division_code }} -</span> {{ user.DivisionName }}
                                            </template>
                                            <template v-else>
                                                -- No Employee Division Set --
                                            </template>
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col text-muted">Assigned Jobsites ({{ jobsites.length }}):</div>
                                        <div class="col-md-8">
                                            <div v-for="jobsite in jobsites" class="mb-1">
                                                <router-link :to="`/jobsites/view/${jobsite.JobsiteId}`">
                                                    <span v-if="jobsite.JobsiteNumber">{{ jobsite.JobsiteNumber }} - </span>{{ jobsite.JobsiteName }}
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="user.allow_password_login === 1">
                                        <div class="col text-muted">Use Password Login:</div>
                                        <div class="col-md-8">
                                            <label class="badge badge-info">ON</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12" v-if="this.$root.hasPermission('settings.manage.users')">
                    <div class="card mb-3">
                        <div class="card-header"><strong><i class="fa fa-lock"></i> Roles</strong></div>
                        <div class="card-body">
                            <div class="align-items-center" v-for="role in user.roles">
                                <div class="badge badge-secondary mt-1 mr-1">{{ role.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-header"><strong>Permissions - Based on Roles</strong></div>
                        <div class="card-body">
                            <div style="max-height: 175px; overflow-y: auto;">
                                <div class="align-items-center" v-for="perm in permissions">
                                    <div class="mt-1 mr-1">
                                        <i class="fa fa-question-circle" :title="`${perm.description}`"></i> {{ perm.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === 'inspections'" @click="curTab = 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.manage'])">
                    <i class="fa fa-list"></i> Inspections <template v-if="inspectionCount != null">({{ inspectionCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'incidents_created'" @click="curTab = 'incidents_created'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.manage'])">
                    <i class="fa fa-stethoscope"></i> Incidents Created <template v-if="incidentCount != null">({{ incidentCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'incidents_involved'" @click="curTab = 'incidents_involved'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.manage'])">
                    <i class="fa fa-stethoscope"></i> Incidents Involved In <template v-if="incidentCount != null">({{ involvedCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'actions'" @click="curTab = 'actions'" v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                    <i class="fa fa-wrench"></i> Corrective Actions <template v-if="actionCount != null">({{ actionCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'goals'" @click="curTab = 'goals'" v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                    Inspection Goals <template v-if="goalCount != null">({{ goalCount }})</template>
                    <router-link :to="`/profile/reminders/edit?user_id=${user.UserId}`" class="btn btn-xs btn-success ml-1" title="Create Inspection Goal" style="font-size: 0.7rem;">
                        <i class="fa fa-plus-circle"></i>
                    </router-link>
                </b-nav-item>
                <b-nav-item :active="curTab === 'logins'" @click="curTab = 'logins'" v-if="this.$root.is_admin">
                    <i class="fa fa-lock"></i> Login History <template v-if="loginCount != null">({{ loginCount }})</template>
                </b-nav-item>
                <b-nav-item :active="curTab === 'history'" @click="curTab = 'history'">
                    <i class="fa fa-clock-o"></i> Edit History <template v-if="historyCount != null">({{ historyCount }})</template>
                </b-nav-item>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
              <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === 'inspections'" @click="curTab = 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.manage'])">
                        <i class="fa fa-list"></i> Inspections <template v-if="inspectionCount != null">({{ inspectionCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'incidents_created'" @click="curTab = 'incidents_created'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspectionss.manage'])">
                        <i class="fa fa-stethoscope"></i> Incidents Created <template v-if="incidentCount != null">({{ incidentCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'incidents_involved'" @click="curTab = 'incidents_involved'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.manage'])">
                        <i class="fa fa-stethoscope"></i> Incidents Involved In <template v-if="incidentCount != null">({{ involvedCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'actions'" @click="curTab = 'actions'" v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                        <i class="fa fa-wrench"></i> Corrective Actions <template v-if="actionCount != null">({{ actionCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'goals'" @click="curTab = 'goals'" v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                        Inspection Goals <template v-if="goalCount != null">({{ goalCount }})</template>
                        <router-link :to="`/profile/reminders/edit?user_id=${user.UserId}`" class="btn btn-xs btn-success ml-1" title="Create Inspection Goal" style="font-size: 0.7rem;">
                            <i class="fa fa-plus-circle"></i>
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'logins'" @click="curTab = 'logins'" v-if="this.$root.is_admin">
                        <i class="fa fa-lock"></i> Login History <template v-if="loginCount != null">({{ loginCount }})</template>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'history'" @click="curTab = 'history'">
                        <i class="fa fa-clock-o"></i> Edit History <template v-if="historyCount != null">({{ historyCount }})</template>
                    </b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="mt-2">
                <div class="card" v-show="curTab === 'inspections'" v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.manage'])">
                    <div class="card-body">
                        <inspection-list assetType="User" :assetId="UserId" @inspectionListCount="inspectionListCount" />
                    </div>
                </div>
                <div class="card" v-show="curTab === 'incidents_created'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.manage'])">
                    <div class="card-body">
                        <incident-list assetType="User" :assetId="parseInt(UserId)" @incidentListCount="incidentListCount" />
                    </div>
                </div>
                <div class="card" v-show="curTab === 'incidents_involved'" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.manage'])">
                    <div class="card-body">
                        <incident-list assetType="personnel" :assetId="parseInt(UserId)" @incidentListCount="involvedIncidentListCount" />
                    </div>
                </div>
                <div class="card" v-show="curTab === 'actions'" v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                    <div class="card-body">
                        <corrective-action-list assetType="User" :assetId="UserId" @correctiveActionCount="correctiveActionCount" />
                    </div>
                </div>
                <div class="card" v-show="curTab === 'goals'" v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.manage'])">
                    <div class="card-body">
                        <inspection-goal-list :user_id="user.UserId" @inspectionGoalList="goalListCount"></inspection-goal-list>
                    </div>
                </div>
                <div class="card" v-show="curTab === 'logins'" v-if="this.$root.is_admin">
                    <div class="card-body">
                        <v-server-table ref="userTable" :url="`/users/logins/${user.UserId}`" :columns="userColumns" :options="userOptions">

                            <template slot="LoginDate" slot-scope="props">
                                {{ props.row.LoginDate | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
                            </template>

                        </v-server-table>
                    </div>
                </div>
                <div class="card" v-show="curTab === 'history'">
                    <div class="card-body">
                        <history-list recordType="User" :recordId="user.UserId" @historyCount="(total) => { this.historyCount = total; }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                curTab: 'inspections',
                loading: true,
                userTimezone: this.$store.state.user.timezone,
                UserId: this.$route.params.id,
                actions: [],
                user: {},
                inspectionCount: null,
                incidentCount: null,
                involvedCount: null,
                actionCount: null,
                goalCount: null,
                loginCount: null,
                historyCount: null,
                permissions: [],
                jobsites: [],

                actionFields: [
                    {key: 'status_name', label: 'Status'},
                    {key: 'asset_type_pretty', label: 'Attached To'},
                    {key: 'asset_name', label: 'Name'},
                ],

                statusOptions: [{
                    id: 1,
                    name: 'Closed'
                }, {
                    id: 2,
                    name: 'Open'
                }],

                settingsTabs: {
                    inspections: 'Inspections',
                    incidents_created: 'Incidents Created',
                    incidents_involved: 'Incidents Involved In',
                    actions: 'Corrective Actions',
                    goals: 'Inspection Goals',
                },

                userColumns: ['LoginDate'],
                userOptions: {
                    headings: {
                        LoginDate: 'Date',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'login.LoginDate',
                    },
                    uniqueKey: 'LoginId',
                    responseAdapter: (response) => {
                        //Emit the count
                        this.loginCount = response.data.count;

                        //Send it
                        return response.data;
                    },
                },
            }
        },

        computed: {
            tabButtonTitle(){
                //Send it
                var icon = '<i class="fa fa-bars"></i>';

                //Switch
                switch(this.curTab)
                {
                    case 'inspections':
                        //Append Count
                        icon = '<i class="fa fa-list"></i>';
                        break;

                    case 'incidents_created':
                    case 'incidents_involved':
                        //Append Count
                        icon = '<i class="fa fa-stethoscope"></i>';
                        break;

                    case 'actions':
                        //Append Count
                        icon = '<i class="fa fa-wrench"></i>';
                        break;
                }

                //Send it
                return icon + ' ' + this.settingsTabs[this.curTab];
            },
        },

        methods: {

            userPartsUpdated(data){
                //Update the cost
                this.user.cost = data.user_cost;

                //Redraw the table
                this.$refs.userParts.refreshData();
            },

            getUser() {
                //Get the data
                this.$http
                    .get('users/view/' + this.UserId)
                    .then(response => {
                        //Set all the data
                        this.user = response.data.user;
                        this.jobsites = response.data.jobsites;
                        this.permissions = response.data.permissions;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteUser() {
                if(confirm('Are you sure you want to delete this user?'))
                {
                    this.$http
                        .post(`users/delete/${this.UserId}`)
                        .then(response => {
                            //Check permissions
                            if(this.$root.hasPermission('settings.manage.users'))
                            {
                                this.$router.push('/users');
                            }
                            else
                            {
                                this.$router.push('/subcontractors/users');
                            }

                        })
                        .catch(response => {
                            alert('Could not delete user at this time');
                        });
                }
            },

            restoreUser: function() {
                if(confirm('Are you sure you want to restore this user?'))
                {
                    this.$http
                        .post(`users/restore/${this.UserId}`)
                        .then(response => {
                            this.$router.go();
                        })
                        .catch(response => {
                            alert('Could not restore user at this time');
                        });
                }
            },

            removeEmployee: function() {
                if (confirm('Are you sure you want to remove the employee record from this user?'))
                {
                    this.user.EmployeeId = null;
                    this.user.EmployeeNumber = null;

                    this.$http
                        .post(`users/edit/${this.UserId}`, this.user)
                        .then(response => {
                            this.$router.go();

                        })
                        .catch(response => {
                            alert('Could not remove employee record at this time');
                        });
                }
            },

            inspectionListCount(count){
                //SEt it
                this.inspectionCount = count;
            },

            incidentListCount(count){
                //Set it
                this.incidentCount = count;
            },

            involvedIncidentListCount(count){
                this.involvedCount = count;
            },

            correctiveActionCount(count){
                //SEt it
                this.actionCount = count;
            },

            goalListCount(count){
                //SEt it
                this.goalCount = count;
            }
        },
        mounted() {
            //Get the users
            this.getUser();
        }
    }
</script>
